import dayjs from "utils/dayjs";

export const DEFAULT_STRIPE_EXPIRATION_MONTHS = 24;

/** The latest cancelation date when no program says otherwise. */
export const calculateDefaultExpirationDate = () =>
  dayjs().utc().add(DEFAULT_STRIPE_EXPIRATION_MONTHS, "month").endOf("month");
